import React from 'react';
import propTypes from 'prop-types';
export const UserReportIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 77.961 77.96"
      enableBackground="new 0 0 77.961 77.96"
      xmlSpace="preserve"
    >
      <g>
        <path
          d="M33.597,16.789c0-9.06,7.344-16.404,16.404-16.404s16.403,7.344,16.403,16.404c0,9.059-7.344,16.403-16.403,16.403
     S33.597,25.848,33.597,16.789z M56.96,34.311H43.041c-5.707,0-10.884,2.295-14.673,6.003h21.866v33.619H39.793
     c2.729,0.567,2.727,1.338,2.727,2.135c0,0.297,0,0.631-0.256,0.965c3.41,0.382,6.598,0.544,9.549,0.544
     c15.436,0,24.383-4.402,24.936-4.683l1.097-0.557l0.116,0.001V55.312C77.962,43.732,68.54,34.311,56.96,34.311z M40.227,76.06
     c0,0.834-6.874,1.51-15.354,1.51c-8.481,0-15.354-0.676-15.354-1.51c0-0.599,3.546-1.111,8.678-1.354v-2.28H0V41.806h47.939v30.619
     H29.743v2.207C35.834,74.832,40.227,75.394,40.227,76.06z M44.79,69.8V44.168H3.148V69.8H44.79z M11.481,67.73h2.75v-15h-2.75
     V67.73z M15.606,67.73h2.75V55.943h-2.75V67.73z M19.606,67.73h2.75V48.48h-2.75V67.73z M32.095,67.73h2.75v-15h-2.75V67.73z
      M27.97,67.73h2.75V55.943h-2.75V67.73z M23.97,67.73h2.75V50.605h-2.75V67.73z"
        />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};
UserReportIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
UserReportIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
